import { FunctionComponent } from 'react';
import { Chip } from '../../tailwindcomponents';
import { AssignedMechanicSkill } from '../../types/skills';

type SkillsProps = {
    assignedSkills: AssignedMechanicSkill[],
}

const SkillsTab: FunctionComponent<SkillsProps> = ({ assignedSkills }) => {
    return (
        <div className="mt-4 min-h-[200px]">
            <div className="flex flex-wrap items-center justify-center h-full">
                {(assignedSkills.length > 0) &&
                    assignedSkills.map((skill, index) => (
                        <Chip
                            className="h-[50px] p-2 m-2 mb-2 text-[1.2rem] font-semibold"
                            onClick={() => { }}
                            key={index}
                            label={skill.SkillName}
                        />
                    ))
                }
            </div>
        </div>
    )
}
export default SkillsTab